<template>
  <a-card :bordered="false" :loading="loadingCard">
    <h1>小组评审</h1>
    {{projectInfo.projectName}} 小组评审 开发中
    标段id:{{sectionId}}
    <a-steps :current="stepsIndex" @change="stepHandle">
      <a-step v-for='(item,i) in taskList' :title="item.name"/>
    </a-steps>
  </a-card>
</template>

<script>
  import {httpAction, getAction, downFile} from '@/api/manage'
  import {formatDate} from '@/utils/util'

  export default {
    components: {},
    name: "PurchaseCommitteeEval",
    data() {
      return {
        bidProjectId: "",
        sectionId: "",
        loadingCard: false,
        tenderProjectInfo: {},
        projectInfo: {},
        sectionInfo: {},
        workflowInstanceId: 1,
        stepsIndex: 0,
        taskList: [],
      }
    },
    filters: {},
    created() {
    },
    computed: {},
    methods: {
      setBidProjectId(id, sectionId) {
        //1.根据招标编号ID获取招标项目信息和项目信息
        this.bidProjectId = id;
        this.sectionId = sectionId;
        getAction("/ebid-ce/tmBidProject/queryById", {id: this.bidProjectId}).then(res => {
          if (res.success) {
            this.tenderProjectInfo = res.result;
            let projectId = this.tenderProjectInfo.projectId;
            console.log("projectId:" + projectId);
            //2.查询项目信息
            getAction("/ebid-ce/tmProject/queryById", {id: projectId}).then(res => {
              if (res.success) {
                this.projectInfo = res.result;
              } else {

              }
            })
          } else {

          }

          //2.根据招标编号ID获取标段包信息
          getAction("/ebid-ce/tmBidSection/queryByBidProjectId", {bidProjectId: this.bidProjectId}).then(res => {
            if (res.success) {
              this.sectionInfo = res.result;
              console.log(this.sectionInfo);
            } else {

            }
          })
        })
        this.getAppraiseStep();
      },
      getAppraiseStep() {
        getAction("/ebid-ce/boWfInstStep/getAppraiseStep/" + this.workflowInstanceId, {}).then(res => {
          if (res.success) {
            for (let i = 0; i < res.result.length; i++) {
              let model = res.result[i];
              this.taskList.push(model);
            }
            console.log(res.result)
          } else {

          }
        })
      },
      stepHandle(index) {
        this.stepsIndex = index;
        console.log(this.taskList[index], index, "stepHandle");
      }
    }
  }
</script>

<style lang="less" scoped>

</style>